(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ils-bag-pairing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ils-bag-pairing')) {
    const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/[^a-z0-9]+/g, ' ').trim();
    const colors = [
      ['dark-brown','aci kahve|acikahve|dark brown|chocolate|espresso'], ['charcoal','antrasit|fume|koyu gri|charcoal|dark gray|dark grey'],
      ['navy','lacivert|navy'], ['cream','ekru|krem|ecru|cream|ivory|off white'], ['taupe','vizon|taupe|mink'], ['tan','taba|tan|cognac'], ['camel','camel'],
      ['burgundy','bordo|burgundy|wine'], ['blush','pudra|blush'], ['lilac','lila|lilac|lavender'], ['gold','gold|altin'], ['silver','gumus|silver'],
      ['black','siyah|black'], ['white','beyaz|white'], ['beige','bej|beige|nude'], ['brown','kahve|brown'], ['red','kirmizi|red'], ['pink','pembe|pink'],
      ['purple','mor|purple'], ['blue','mavi|mavisi|blue'], ['green','yesil|yesili|green|mint|olive'], ['yellow','sari|yellow'], ['orange','turuncu|orange'], ['gray','gri|gray|grey']
    ].map(([color, terms]) => [color, new RegExp('(?:^| )(' + terms + ')(?: |$)')]);
    const detect = value => {
      const text = normalize(value);
      return colors.map(([color, pattern]) => ({ color, match: text.match(pattern) })).filter(entry => entry.match).sort((a,b) => a.match.index - b.match.index || b.match[1].length - a.match[1].length)[0]?.color || '';
    };
    const colorOf = item => detect(item.dataset.color) || detect(item.dataset.title) || detect(item.dataset.tags);
    const material = value => normalize(value).match(/mat deri|matte leather|hakiki deri|genuine leather|rugan|patent|suet|suede|saten|satin|hasir|straw|jut|jute|krose|crochet|keten|linen/)?.[0] || '';
    const palettes = {
      black:['cream','silver','burgundy','gray','beige','charcoal'], white:['beige','tan','silver','navy','cream'], beige:['tan','cream','brown','burgundy','taupe','gold'],
      cream:['tan','beige','brown','gold','taupe'], taupe:['cream','brown','beige','burgundy','tan'], tan:['cream','beige','dark-brown','navy','gold'], camel:['cream','brown','beige','navy','gold'],
      brown:['cream','tan','burgundy','beige','gold','dark-brown'], 'dark-brown':['cream','tan','burgundy','beige','brown','gold'], burgundy:['black','cream','dark-brown','blush','gold'],
      red:['black','cream','beige','gold','burgundy'], blush:['cream','beige','gold','burgundy','pink'], pink:['cream','silver','beige','burgundy','blush'],
      lilac:['cream','silver','beige','blush','purple'], purple:['cream','silver','black','lilac'], navy:['cream','tan','silver','beige','blue'], blue:['cream','silver','tan','navy','beige'],
      green:['cream','tan','beige','gold','brown'], yellow:['cream','tan','beige','gold','white'], orange:['cream','tan','beige','brown','gold'],
      gold:['black','cream','beige','brown','tan'], silver:['black','white','gray','navy','cream'], gray:['silver','black','cream','burgundy','charcoal'], charcoal:['silver','black','gray','cream','burgundy']
    };
    let catalogPromise;
    async function loadCatalog(source) {
      const candidates = new Map();
      let url = new URL(source, location.origin);
      const seen = new Set();
      while (url && !seen.has(url.href)) {
        seen.add(url.href);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Bag catalog unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.querySelector('[data-ils-bag-source]');
        if (!root) throw new Error('Bag catalog missing');
        root.querySelectorAll('template[data-bag]').forEach(item => candidates.set(item.dataset.id, item));
        url = root.dataset.next ? new URL(root.dataset.next, location.origin) : null;
        if (url) url.searchParams.set('section_id', 'ils-bag-source');
      }
      return [...candidates.values()];
    }
    customElements.define('ils-bag-pairing', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.initialize(); }
        }, { rootMargin: '600px' });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.events?.abort(); this.observer = null; }
      async initialize() {
        const targetColor = colorOf(this);
        if (!targetColor || this.loaded) return;
        try {
          catalogPromise ||= loadCatalog(this.dataset.source).catch(error => { catalogPromise = null; throw error; });
          const items = await catalogPromise;
          if (!this.isConnected) return;
          const targetMaterial = material(this.dataset.title);
          const palette = palettes[targetColor] || [];
          const ranked = items.filter(item => item.dataset.id !== this.dataset.id).map((item, order) => ({
            item, color: colorOf(item), group: item.dataset.tags.match(/groupcode\S+/i)?.[0] || item.dataset.id,
            order, score: (item.dataset.available === 'true' ? 1000 : 0) + (targetMaterial && material(item.dataset.title) === targetMaterial ? 100 : 0) - (/plaj|beach/.test(normalize(item.dataset.title)) && !/sandal|terlik|slide/.test(normalize(this.dataset.title)) ? 200 : 0)
          }));
          const used = new Set();
          const select = (pool, diversify = false) => {
            const result = [];
            const chosenColors = new Set();
            if (diversify) {
              for (const entry of pool) {
                if (used.has(entry.group) || chosenColors.has(entry.color)) continue;
                used.add(entry.group); chosenColors.add(entry.color); result.push(entry);
                if (result.length === 4) return result;
              }
            }
            for (const entry of pool) { if (used.has(entry.group)) continue; used.add(entry.group); result.push(entry); if (result.length === 4) break; }
            return result;
          };
          const exact = select(ranked.filter(entry => entry.color === targetColor).sort((a,b) => b.score - a.score || a.order - b.order));
          const compatible = select(ranked.filter(entry => entry.color !== targetColor && palette.includes(entry.color)).sort((a,b) => (b.score - palette.indexOf(b.color) * 10) - (a.score - palette.indexOf(a.color) * 10) || a.order - b.order), true);
          this.track = this.querySelector('.ils-bags__track');
          for (const [entries,label,kind] of [[exact,this.dataset.same,'same'],[compatible,this.dataset.pair,'compatible']]) {
            for (const entry of entries) {
              const fragment = entry.item.content.cloneNode(true);
              const card = fragment.querySelector('article');
              card.dataset.match = kind; card.dataset.color = entry.color; card.dataset.group = entry.group;
              fragment.querySelector('.ils-bags__match').textContent = label;
              this.track.append(fragment);
            }
          }
          if (!exact.length && !compatible.length) return;
          this.loaded = true;
          this.querySelector('section').hidden = false;
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.querySelector('.ils-bags__previous').addEventListener('click', () => this.move(-1), options);
          this.querySelector('.ils-bags__next').addEventListener('click', () => this.move(1), options);
          this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
          this.update();
        } catch { this.querySelector('section').hidden = true; }
      }
      move(direction) {
        this.track.scrollBy({ left: direction * (this.track.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        this.querySelector('.ils-bags__previous').disabled = this.track.scrollLeft < 2;
        this.querySelector('.ils-bags__next').disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ils-detail-colors')) {
  const cache = new Map();
  async function loadColors(base, group) {
    const url = new URL(base, location.origin);
    url.search = new URLSearchParams({q:'tag:"' + group.replace(/["\\]/g, '') + '"',type:'product','options[unavailable_products]':'last','options[prefix]':'none',section_id:'ils-edit'});
    let next = url.href;
    const visited = new Set(), entries = new Map();
    while (next && !visited.has(next)) {
      visited.add(next);
      const response = await fetch(next);
      if (!response.ok) throw new Error('Colors unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = doc.querySelector('[data-ils-color-source]');
      if (!source) throw new Error('Colors unavailable');
      source.querySelectorAll('template[data-color-product]').forEach(entry => {
        if (JSON.parse(entry.dataset.tags).includes(group)) entries.set(entry.dataset.id, entry);
      });
      next = source.dataset.next;
      if (next) {
        const page = new URL(next, location.origin);
        if (page.origin !== location.origin) throw new Error('Invalid color source');
        page.searchParams.set('section_id','ils-edit');
        next = page.href;
      }
    }
    return [...entries.values()];
  }
  customElements.define('ils-detail-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, {rootMargin:'300px'});
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async load() {
      const group = this.dataset.group;
      try {
        if (!cache.has(group)) cache.set(group,loadColors(this.dataset.searchUrl,group));
        const entries = await cache.get(group);
        if (!this.isConnected || this.loaded || entries.length < 2) return;
        const list = this.querySelector('[role="list"]');
        for (const entry of entries) {
          const item = document.createElement('span');
          item.setAttribute('role','listitem');
          item.append(entry.content.cloneNode(true));
          if (entry.dataset.id === this.dataset.productId) item.querySelector('a').setAttribute('aria-current','true');
          list.append(item);
        }
        this.loaded = true;
        this.hidden = false;
      } catch { cache.delete(group); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
